import Vue from 'vue'
import Vuex from 'vuex'
import Window1 from './window1'
import Window2 from './window2'
import Window3 from './window3'
import Window4 from './window4'
import Window5 from './window5'
import Window6 from './window6'
import Color from './color'
import Curtains from './curtains'
import Tulles from './tulles'
import Karniz from './Karniz'
import Rooms from './rooms'
import AddOptions from './addOptions'
import Final from './final'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Rooms, Window1, Window2, Window3, Window4, Window5, Window6, Color, Curtains, Tulles, Karniz, AddOptions, Final
  }
})
